import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { VirtualizedCardList } from '@futrli/predict/ui/virtualized-card-list/virtualized-card-list';
import { VirtualizedCardListEmptyState } from '@futrli/predict/ui/virtualized-card-list/virtualized-card-list-empty-state';
import { ProcessedUserRow } from '@futrli/views/processors/users/usersList';

import { ROW_HEIGHT_DEFAULT, UserRow } from './components/user-row/user-row';

interface UsersListProps {
  isLoading?: boolean;
  users?: ProcessedUserRow[];
}

export const UsersList = ({ isLoading = false, users = [] }: UsersListProps) => {
  const intl = useIntl();

  const renderRow = useCallback((user: ProcessedUserRow) => <UserRow user={user} />, []);

  const rowHeight = useCallback(() => ROW_HEIGHT_DEFAULT, []);

  return (
    <VirtualizedCardList<ProcessedUserRow>
      data={users}
      emptyState={
        <VirtualizedCardListEmptyState
          title={intl.formatMessage({
            id: 'predict.workspaces.no_users',
            defaultMessage: 'No users to show'
          })}
        />
      }
      isLoading={isLoading}
      renderRow={renderRow}
      rowHeight={rowHeight}
    />
  );
};
